import type {
  AudiencePreviewRequest,
  AudiencePreviewResponse,
  CampaignResponse,
  CreateCampaignRequest,
  PaginatedResponse,
  UpdateCampaignRequest,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export interface ListCampaignsParams {
  readonly status?: string;
  readonly includeArchived?: boolean;
  readonly cursor?: string;
  readonly limit?: number;
}

export const communicationsApi = {
  list(params: ListCampaignsParams = {}, signal?: AbortSignal) {
    return apiRequest<PaginatedResponse<CampaignResponse>>('/communications/campaigns', {
      query: { ...params },
      signal,
    });
  },

  get(id: string, signal?: AbortSignal) {
    return apiRequest<CampaignResponse>(`/communications/campaigns/${id}`, { signal });
  },

  previewAudience(body: AudiencePreviewRequest) {
    return apiRequest<AudiencePreviewResponse>('/communications/campaigns/audience-preview', {
      method: 'POST',
      body,
    });
  },

  create(body: CreateCampaignRequest) {
    return apiRequest<CampaignResponse>('/communications/campaigns', { method: 'POST', body });
  },

  update(id: string, body: UpdateCampaignRequest) {
    return apiRequest<CampaignResponse>(`/communications/campaigns/${id}`, {
      method: 'PATCH',
      body,
    });
  },

  send(id: string) {
    return apiRequest<CampaignResponse>(`/communications/campaigns/${id}/send`, {
      method: 'POST',
    });
  },

  /** There is no delete. A draft is archived — see ADR-0006. */
  archive(id: string) {
    return apiRequest<CampaignResponse>(`/communications/campaigns/${id}/archive`, {
      method: 'POST',
    });
  },
};
